import React, { useContext } from "react";
import { useState } from "react";
import Swal from "sweetalert2";
import { log } from "util";
import { CreditoDetalles } from "../../../functions/Validaciones/CreditoDetalles";
import { CuotaPago } from "../../../functions/Validaciones/CuotaPago";
import { SaldoCuotas } from "../../../functions/Validaciones/CuotasSaldo";
import ModalNotificacion from "../../personas/modals/ModalNotificacion";
import { PersonasContext, AuthContext, Link, clienteAxios } from "../../shared/";

const PreCalificacionEscritorio = ({
  selectUsuario,
  setSelectUsuario,
  item,
  garantes,
  editar,
  solicitarPrecalificacion,
  precalificar,
  calificaciones,
  generarCredito,
  generarCreditoEspecial,
  modalNoti
}) => {
  const personasContext = useContext(PersonasContext);
  const { SeleccionarPrecalificar } = personasContext;

  const authContext = useContext(AuthContext);
  const { usuario } = authContext;

  const [search, setSearch] = useState("");

  const acciones = () => {
    switch (item.precalificaciones?.estado) {
      case null:
        return (
          <>
            <option value="Solicitar Precalificacion">
              Solicitar Precalificacion
            </option>
            <option value="Solicitar Revision">
              Notificar
            </option>
          </>
        );

      case "Solicitada":
        if (usuario.rol === "Precalificador") {
          return (
            <>
              <option value="Pre Calificar">Análizar</option>
              <option value="Ver Calificaciones">Ver Análisis Financiero</option>
              <option value="Solicitar Revision">
                Notificar
              </option>
            </>
          );
        }

        if (usuario.rol === "Admin") {
          return (
            <>
              <option value="Pre Calificar">Análizar</option>
              <option value="Ver Calificaciones">Ver Análisis Financiero</option>
              <option value="Solicitar Revision">
                Notificar
              </option>
              <option value="Generar Credito Especial">Generar Credito Especial</option>
            </>
          )
        }
        break;
      //return <option value="Ver Calificaciones">Ver Calificaciones</option>;
      case "Juicio - Ejecución":
      case "Juicio":
        if (usuario.rol === "Precalificador" || usuario.rol === "Admin") {
          return (
            <>
              <option value="Pre Calificar">Análizar</option>
              <option value="Ver Calificaciones">Ver Análisis Financiero</option>
              <option value="Solicitar Revision">
                Notificar
              </option>
            </>
          );
        } else {
          return <>
            <option value="Ver Calificaciones">
              Ver Análisis Financiero
            </option>
            <option value="Solicitar Revision">Notificar</option>
          </>
        }
        break;
      case "Rechazada":
      case "Observada":
        if (usuario.rol === "Precalificador" || usuario.rol === "Admin") {
          return (
            <>
              <option value="Pre Calificar">Análizar</option>
              <option value="Ver Calificaciones">Ver Análisis Financiero</option>
              <option value="Solicitar Revision">
                Notificar
              </option>
            </>
          );
        } else {
          return <>
            <option value="Ver Calificaciones">
              Ver Análisis Financiero
            </option>
            <option value="Solicitar Revision">Notificar</option>
          </>
        }
        break;
      case "Pendiente":
      case "Aceptada":
        if (usuario.rol == "Vendedor") {
          return (
            <>
              <option value="Generar Credito">Generar Credito</option>
              <option value="Ver Calificaciones">Ver Análisis Financiero</option>
              <option value="Solicitar Revision">
                Notificar
              </option>
            </>
          );
        }

        if (usuario.rol === "Precalificador") {
          return <>
            <option value="Pre Calificar">Análizar</option>
            <option value="Ver Calificaciones">
              Ver Análisis Financiero
            </option>
            <option value="Solicitar Revision">Notificar</option>
          </>
        }

        if (usuario.rol === "Admin") {
          return (
            <>
              <option value="Pre Calificar">Análizar</option>
              <option value="Generar Credito Especial">Generar Credito Especial</option>
              <option value="Generar Credito">Generar Credito</option>
              <option value="Ver Calificaciones">Ver Análisis Financiero</option>
              <option value="Solicitar Revision">
                Notificar
              </option>
            </>
          )
        }

      default:
        break;
    }
  };
  /* 
        <option value="Generar Credito">Generar Credito</option>
        <option value="Ver Calificaciones">Ver Calificaciones</option>
        <option value="Solicitar Calificaciones">Solicitar Calificaciones</option>
        {item.estado ? <option value="Solicitar Precalificacion">Solicitar Precalificacion</option> : null} */

  const onChange = (e) => {
    SeleccionarPrecalificar(item);

    switch (e.target.value) {
      case "Editar":
        editar(item.id);
        break;
      case "Generar Credito":
        generarCredito({...item, iddepersona: item.id});
        break;
      case "Generar Credito Especial": {
        generarCreditoEspecial({...item, iddepersona: item.id})
      } break;
      case "Ver Calificaciones":
        calificaciones(item.id);
        break;
      case "Solicitar Precalificacion":
        solicitarPrecalificacion(item.id);
        break;
      case "Pre Calificar":
        precalificar(item.id);
        break;
      case "Solicitar Revision":
        modalNoti({...item, iddepersona: item.id});
        break;
      default:
        break;
    }
  };


  const saldo = SaldoCuotas(item.creditos);

  //Logs
  //console.log(saldo);
  //console.log(item);
  const getEstadoBadgeClass = () => {
    if (!item.precalificaciones) return 'unified-badge-light';

    const estado = item.precalificaciones.estado;
    switch(estado) {
      case 'Aceptada':
        return 'unified-badge-success';
      case 'Rechazada':
      case 'Juicio':
      case 'Juicio - Ejecución':
        return 'unified-badge-danger';
      case 'Observada':
        return 'unified-badge-warning';
      case 'Solicitada':
        return 'unified-badge-info';
      case 'Pendiente':
        return 'unified-badge-secondary';
      default:
        return 'unified-badge-light';
    }
  };

  return (
    <tr className={selectUsuario === item.id ? 'selected' : ''}>
      <td className="text-center">
        <select
          name="opciones"
          className="unified-table-select"
          onChange={onChange}
        >
          <option value="">Seleccione..</option>
          <option value="Editar">Editar</option>
          {acciones()}
        </select>
      </td>
      <td className="text-center"></td>
      <td className="text-start">
        <Link
          to={`/clientes/ver/${item.id}`}
          target="_blank"
          className="unified-table-link"
          onClick={() => setSelectUsuario(item.id)}
        >
          {item.apellido}, {item.nombre} / {item.nro_documento}
        </Link>
      </td>
      <td className="text-center">
        {item.garantes ? (
          <Link
            to={`/clientes/ver/${item.garantes.id_garante}`}
            target="_blank"
            className="unified-table-link"
          >
            {item.garantes.garante.nombre} {item.garantes.garante.apellido}
          </Link>
        ) : (
          <span style={{ color: '#9ca3af', fontSize: '13px' }}>Sin Garantes</span>
        )}
      </td>
      <td className="text-center">
        <span className={`unified-badge ${getEstadoBadgeClass()}`}>
          {item.precalificaciones ? item.precalificaciones.estado : 'En espera'}
        </span>
      </td>
      <td className="text-center">
        <span className="unified-money">
          $ {new Intl.NumberFormat('de-DE').format(item.precalificaciones ? item.precalificaciones.limite : 0)}
        </span>
      </td>
      <td className="text-center">
        <span className={`unified-money ${(item.precalificaciones?.limite - saldo) < 0 ? 'unified-money-negative' : ''}`}>
          $ {new Intl.NumberFormat('de-DE').format(item.precalificaciones ? item.precalificaciones.limite - saldo : 0)}
        </span>
      </td>
      <td className="text-center">
        <span className={item.precalificaciones?.premium === 'SI' ? 'unified-premium-yes' : 'unified-premium-no'}>
          {item.precalificaciones ? item.precalificaciones.premium : "NO"}
        </span>
      </td>
    </tr>
  );
};

export default PreCalificacionEscritorio;
